module.exports = __webpack_public_path__ + "img/handwriting@2x.a28cde3b.png";